import React,{useState} from 'react';
import { Link, NavLink } from 'react-router-dom';
import {AiOutlineBars} from 'react-icons/ai'
import {FaTimes} from 'react-icons/fa'

function Navbar() {
    const [toggle, setToggle] = useState(false)

    const handleToggle = () => {
        setToggle(!toggle)
    }
    const navLinkStyles = ({ isActive }) => {
        return {
             color: isActive ? 'blue' : 'black',
        }
       
    }
    return (
      <>
       <nav className='flex items-center bg-white w-full h-16 shadow '>
          <div className='font-[Pacifico,cursive] font-extrabold text-3xl pl-10  '>
               <NavLink className='flex justify-center items-center md:justify-start'  to="/">
              Disney
            </NavLink>
          </div>
          
                <div className={ ` ${toggle ? 'block' : 'hidden'} w-full block md:flex md:items-center md:w-auto `}>
                <div className='flex '>
                   <div className='px-4 text-[15px] font-bold pl-5  '>
              <NavLink style={navLinkStyles} to= "/disney" className='dropdown' >
                  DISNEY+
                  <div className='dropdown-content'>
                      <Link to='/'>
                          <p className='pb-8 hover:text-blue-600'>discover more</p>
                      </Link>
                      <Link to='/'>
                     <p className='hover:text-blue-600'>lntroducing Disney+</p>

                      </Link>
              </div>
              </NavLink>
              
          </div>

           <div className='px-4 text-[15px] font-bold'>
              <NavLink style={navLinkStyles} to= "/shops" >
                  SHOPS
              </NavLink>
          </div>

           <div className='px-4 text-[15px] font-bold     '>
              <NavLink style={navLinkStyles} to= "/movies" className='dropdown   ' >
                  MOVIES
                   <div className='dropdown-content h-[300px]  w-[200px]'>
                      <Link to='/action'>
                          <p className='pb-5 hover:text-blue-600'>Action</p>
                      </Link>
                      
                      <Link to='/fantasy'>
                     <p className='pb-5 hover:text-blue-600'>Fantasy</p>

                      </Link>

                      <Link to='/history'>
                     <p className='pb-5 hover:text-blue-600'>History</p>

                      </Link>
                      <Link to='/comedy'>
                     <p className=' pb-5 hover:text-blue-600'>Comedy</p>

                      </Link>
                      <Link to='/crime'>
                     <p className='hover:text-blue-600'>Pixar movies</p>

                      </Link>

                      <Link to='/documentary'>
                     <p className='hover:text-blue-600'>ocumentary</p>

                      </Link>

                      <Link to='/horror'>
                     <p className='hover:text-blue-600'>Horror</p>

                      </Link>

                      <Link to='/music'>
                     <p className='hover:text-blue-600'>Music</p>

                      </Link>
              </div>
              </NavLink>
          </div>

           <div className='px-4 text-[15px] font-bold'>
              <NavLink  to= "/parks"className='dropdown' >
                  PARKS
                   <div className='dropdown-content'>
                      <Link to='/'>
                          <p className='pb-4 hover:text-blue-600'>Disneyland Paris</p>
                      </Link>
                      <Link to='/'>
                     <p className='hover:text-blue-600 pb-4'>Walt Disney World</p>

                      </Link>

                      <Link to='/'>
                     <p className='hover:text-blue-600'> Disney Cruise Line</p>

                      </Link>
              </div>
              </NavLink>
                  </div>
                  
                 
              </div> 
              
            
         
          </div>
                <div className='flex justify-end absolute text-2xl  right-0 px-4 md:hidden' onClick={handleToggle}>
                    {toggle ?<FaTimes/> :<AiOutlineBars />  }
              
              
            </div>
          
        
            </nav>
            
            
      </>
     
  )
}

export default Navbar
